import { Well } from '@/components/Elements';
import { ContentLayout } from '@/components/Layout';
import { PageHeading } from '@/components/Layout/PageHeading';

import { EmploymentDocuments } from '../components/EmploymentDocuments';

const title = 'Documents';

export const Documents = () => (
  <ContentLayout title={title}>
    <Well>
      <>
        <PageHeading title={title} />
        <EmploymentDocuments />
      </>
    </Well>
  </ContentLayout>
);
